"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinishProcessingRequestStruct = void 0;
const superstruct_1 = require("superstruct");
exports.FinishProcessingRequestStruct = (0, superstruct_1.type)({
    placeId: (0, superstruct_1.string)(),
    appointmentId: (0, superstruct_1.string)(),
    noShow: (0, superstruct_1.optional)((0, superstruct_1.boolean)()),
    lateShow: (0, superstruct_1.optional)((0, superstruct_1.boolean)()),
    counterId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
});
//# sourceMappingURL=FinishProcessingRequest.js.map